import React from "react";
import Sidebar from "./Sidebar";

export default function Layout({ children }) {
  return (
    <div className="App flex">
      <Sidebar />
      <main className="flex-1 ml-64 min-h-screen bg-[#F9F9F8]">
        {children}
      </main>
    </div>
  );
}
